export default axios => ({
    login(payload) {
        return axios.post('/doctor/auth', payload);
    },
    logout() {
        return axios.post('auth/logout');
    },
    clear() {
        return axios.post('auth/clear');
    },
    refreshToken(payload) {
        return axios.get(`/doctor/auth/refresh`, payload);
    },
    profile(payload) {
        return axios.get(`doctor/me`, payload);
    },
    changePass(payload) {
        return axios.post('profile/change-password', payload);
    }
})
